<template>
<span>
<pazar-sanati-hero></pazar-sanati-hero>
<pazar-sanati-details></pazar-sanati-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import PageFooter from '@/components/PageFooter';
import PazarSanatiHero from '@/components/PazarSanatiHero';
import PazarSanatiDetails from '@/components/PazarSanatiDetails';
export default {
    name :'pazarsanati',
    components:{
     PazarSanatiHero,
     PazarSanatiDetails,
        PageFooter
    }

    
};
</script>


